import { render, staticRenderFns } from "./FormulateTagField.vue?vue&type=template&id=76b4714b&"
import script from "./FormulateTagField.js?vue&type=script&lang=js&"
export * from "./FormulateTagField.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b4714b')) {
      api.createRecord('76b4714b', component.options)
    } else {
      api.reload('76b4714b', component.options)
    }
    module.hot.accept("./FormulateTagField.vue?vue&type=template&id=76b4714b&", function () {
      api.rerender('76b4714b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Formulate/FormulateTagField/FormulateTagField.vue"
export default component.exports